import { Context, type Effect, Layer, type Scope } from "effect";
import type { ReviewDeepLinkState } from "@workerstation/shared/review-deep-link";
import type { ReviewNavigationFailure, ReviewNavigationListener, ReviewNavigationMode } from "./model.ts";

export interface ReviewNavigationDriver {
  readonly receive: (review: boolean) => Effect.Effect<void, ReviewNavigationFailure>;
  readonly navigate: (state: ReviewDeepLinkState, mode: ReviewNavigationMode) => Effect.Effect<void, ReviewNavigationFailure>;
}
export class ReviewNavigationIo extends Context.Service<ReviewNavigationIo, {
  readonly open: (notify: ReviewNavigationListener, canRead: () => boolean, report: (failure: ReviewNavigationFailure) => void) => Effect.Effect<ReviewNavigationDriver, ReviewNavigationFailure, Scope.Scope>;
}>()("workerstation/frontend/ReviewNavigationIo") {}
export const ReviewNavigationIoTest = (io: typeof ReviewNavigationIo.Service) => Layer.succeed(ReviewNavigationIo, io);
export interface ReviewNavigationSession {
  readonly receive: (review: boolean) => Effect.Effect<void>;
  readonly navigate: (state: ReviewDeepLinkState, mode?: ReviewNavigationMode) => Effect.Effect<void>;
}
export class ReviewNavigations extends Context.Service<ReviewNavigations, {
  readonly open: (notify: ReviewNavigationListener) => Effect.Effect<ReviewNavigationSession, never, Scope.Scope>;
}>()("workerstation/frontend/ReviewNavigations") {}
